<modal-popup
  [flexible]="true"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.general.processRunStatus'"
>
  <div class="container">
    <data-box
      class="w-full t-row--med"
      [isWrapped]="false"
      [data]="doc"
      [displayFilter]="['docId', 'docName', 'createDateFormatted', 'remainingProcessingTime']"
      [columns]="1"
    ></data-box>


    <p-progressBar [value]="displayCompletedPct"></p-progressBar>

    <div class="steps">
      <p *ngFor="let step of status.steps; let first = first">
        <i [ngClass]="first ? 'current-processing-step' : 'fas fa-check c-success'"></i>&nbsp; {{ step.stepCategory }}
        <ng-container *ngIf="first"> ({{ step.stepDescr }})

        </ng-container>
        <processing-label *ngIf="first" [withText]="false"></processing-label>
      </p>
    </div>
  </div>
</modal-popup>
